import React from 'react';
import { Plus } from 'lucide-react';

/**
 * Barra fina invisível que aparece no hover entre dois itens do documento.
 * Ao clicar, dispara o callback (tipicamente abre o InsertMenu na posição correspondente).
 *
 * Por padrão tem altura pequena (alvo de hover) mas mantém o layout visualmente discreto
 * até o usuário mover o mouse próximo. Ao passar o cursor, mostra uma linha e um botão "+".
 */
const InsertHoverBar = ({ onClick, title = 'Inserir item aqui' }) => {
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        if (onClick) onClick();
      }}
      title={title}
      style={{
        position: 'relative',
        height: '12px',
        margin: '0',
        cursor: 'pointer',
        userSelect: 'none',
        WebkitUserSelect: 'none',
      }}
      className="doc-editor-insert-hover-bar"
    >
      {/* Linha horizontal — invisível por default, visível no hover */}
      <span
        aria-hidden="true"
        style={{
          position: 'absolute',
          top: '50%',
          left: '8px',
          right: '8px',
          height: '2px',
          backgroundColor: 'var(--ikaro-purple-accent)',
          opacity: 0,
          transform: 'translateY(-50%)',
          transition: 'opacity 0.12s ease',
          pointerEvents: 'none',
        }}
        className="doc-editor-insert-hover-line"
      />
      {/* Botão "+" central — invisível por default, visível no hover */}
      <span
        aria-hidden="true"
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '22px',
          height: '22px',
          borderRadius: '50%',
          backgroundColor: 'var(--ikaro-purple-accent)',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: 0,
          transition: 'opacity 0.12s ease',
          pointerEvents: 'none',
          boxShadow: '0 1px 4px rgba(0,0,0,0.18)',
        }}
        className="doc-editor-insert-hover-plus"
      >
        <Plus size={14} strokeWidth={2.5} />
      </span>
      {/* Hover state via CSS (style injetado inline via <style> abaixo) não é trivial em React inline.
          Usamos onMouseEnter/Leave para alternar visibilidade. */}
      <HoverEffect />
    </div>
  );
};

/**
 * Subcomponente que aplica os efeitos de hover usando event handlers no parent.
 * (Inline styles não suportam pseudo-classes; usar handlers locais mantém o componente
 *  autocontido e evita criar uma folha de estilos só para isso.)
 */
const HoverEffect = () => {
  return (
    <span
      aria-hidden="true"
      style={{
        position: 'absolute',
        inset: 0,
      }}
      onMouseEnter={(e) => {
        const parent = e.currentTarget.parentElement;
        if (!parent) return;
        const line = parent.querySelector('.doc-editor-insert-hover-line');
        const plus = parent.querySelector('.doc-editor-insert-hover-plus');
        if (line) line.style.opacity = '0.5';
        if (plus) plus.style.opacity = '1';
      }}
      onMouseLeave={(e) => {
        const parent = e.currentTarget.parentElement;
        if (!parent) return;
        const line = parent.querySelector('.doc-editor-insert-hover-line');
        const plus = parent.querySelector('.doc-editor-insert-hover-plus');
        if (line) line.style.opacity = '0';
        if (plus) plus.style.opacity = '0';
      }}
    />
  );
};

export default InsertHoverBar;
